import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const PersonCard = ({ name, link, imgSlug }) => (
  <a href={link} style={{flexGrow: 1}}>
    <div
      style={{
        border: `1px solid #CCC`,
        boxShadow: `0px 5px 5px 0px #CCC`,
        margin: `10px`,
        padding: `30px`,
        display: `flex`,
        flexDirection: `column`,
        alignItems: `center`,
      }}
    >
      <img
        style={{
          maxWidth: `100px`,
          border: `1px solid #CCC`,
          borderRadius: `128px`,
        }}
        src={`https://avatars3.githubusercontent.com/u/${imgSlug}?s=128`}
      />
      <h5 style={{ textAlign: `center` }}>{name}</h5>
    </div>
  </a>
)

const IndexPage = () => (
  <Layout>
    <SEO title="Team" />
    <h1>Team</h1>
    <p>Lovingly made by the following people.</p>
    <div
      style={{
        display: `flex`,
        justifyContent: `space-between`,
      }}
    >
      <PersonCard
        name="Dean"
        link="https://github.com/dlalap"
        imgSlug="8119556"
      />
      <PersonCard
        name="Masa"
        link="https://github.com/ConfusedSky"
        imgSlug="12839429"
      />
      <PersonCard
        name="Michelle"
        link="https://github.com/michelleyuan"
        imgSlug="9101675"
      />
      <PersonCard
        name="Erik"
        link="https://github.com/ErikUggeldahl"
        imgSlug="1815895"
      />
    </div>
  </Layout>
)

export default IndexPage
